export type ILoginUser = {
    email: string;
    password: string;
};

export const LoginUserDTO = (val: ILoginUser) => ({
    email: val.email,
    password: val.password,
});
